import React from 'react';
import CarouselComponent from '../common/carousel';  // Make sure this matches your export
import Services from '../components/services';
import Categories from '../components/Categories';
import Courses from './courses';

const HomePage = () => {
  return (
    <main className="fundisha-home-main">
      <CarouselComponent />
      <Services />
      <Categories />
      <Courses />
    </main>
  );
};

export default HomePage;